import React from 'react';
import styles from '../InternalAdminTool.module.scss';

interface LogoHeaderProps {
  accTickImage: string;
  accessLogoTickImage: string;
  organisationId: string;
  corporateSite: string;
}

const LogoHeader: React.FC<LogoHeaderProps> = ({ 
  accTickImage, 
  accessLogoTickImage,
  organisationId,
  corporateSite
}) => {
  return (
    <>
      <div className={styles.logoContainer}>
        <img 
          src={accTickImage} 
          alt="ACC Logo" 
          className={styles.colorLogo} 
        />
        <div className={styles.arrow}>↔</div>
        <img 
          src={accessLogoTickImage} 
          alt="Access Logo" 
          className={styles.colorLogo} 
        />
      </div>
      <div className={styles.title}>Internal Admin Tool</div>
      <div className={styles.subtitle}>Organisation ID: {organisationId}</div>
      <div className={styles.subtitle}>Linked to Corporate Site: {corporateSite}</div>
    </>
  );
};

export default LogoHeader;
